import React, { useCallback, useContext } from 'react'
import TextButton from 'LuxKit/Button/TextButton'
import ExperimentControlPanel from 'components/DevTools/ExperimentControlPanel/ExperimentControlPanel'
import ModalContext from 'contexts/ModalContext'
import { useAppSelector } from 'hooks/reduxHooks'
import { isLEStaffOrAdmin } from 'selectors/accountSelectors'
import AbTestsButtonLabel from './AbTestsButtonLabel'

function ExperimentPanelButton() {
  const isStaff = useAppSelector(isLEStaffOrAdmin)
  const showModal = useContext(ModalContext)

  const openPanel = useCallback(() => {
    showModal(<ExperimentControlPanel />)
  }, [showModal])

  if (!isStaff) {
    return null
  }

  return (
    <TextButton kind="secondary" onClick={openPanel}>
      <AbTestsButtonLabel />
    </TextButton>
  )
}

export default ExperimentPanelButton
